<template>
  <div>
    <apexchart
      type="line"
      height="400"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import apexchart from "vue-apexcharts";
import { dateTimeIsoToLocal } from "@/filters/utils";

export default {
  components: {
    apexchart
  },
  data: function() {
    var context = this;
    context.listaDireita = [];
    context.listaEsquerda = [];
    context.listaExterna = [];
    context.listaIdealMaxima = [];
    context.listaIdealMinima = [];
    context.listaMedicoes = [];
    context.values.forEach(function(item) {
      context.listaDireita.push(item.td);
      context.listaEsquerda.push(item.te);
      context.listaExterna.push(item.t_externa);
      context.listaIdealMaxima.push(item.tMaxIdeal);
      context.listaIdealMinima.push(item.tMinIdeal);
      context.listaMedicoes.push(item.data);
    });
    context.seriesMontada = [
      {
        name: "Temperatura Máxima",
        type: "line",
        data: context.listaIdealMaxima
      },
      {
        name: "Temperatura Externa",
        type: "line",
        data: context.listaExterna
      },
      {
        name: "Temperatura Esquerda",
        type: "line",
        data: context.listaEsquerda
      },
      {
        name: "Temperatura Direita",
        type: "line",
        data: context.listaDireita
      },
      {
        name: "Temperatura Mínima",
        type: "line",
        data: context.listaIdealMinima
      }
    ];
    return {
      listaIdealMinima: [],
      listaEsquerda: [],
      listaIdealMaxima: [],
      listaDireita: [],
      listaExterna: [],
      listaMedicoes: [],
      seriesMontada: [],
      chartOptions: {
        colors: ["#10303D", "#9575CD", "#2196F3", "#4CAF50", "#FF5429"],
        stroke: {
          curve: "straight",
          dashArray: [5, 0, 0, 0, 5],
          width: [4, 2, 2, 2, 4],
          colors: ["#10303D", "#9575CD", "#2196F3", "#4CAF50", "#FF5429"]
        },
        markers: {
          size: [1, 6, 6, 6, 1]
        },
        xaxis: {
          type: "datetime",
          categories: context.listaMedicoes,
          title: {
            text: "Data/Hora de Medição"
          },
          labels: {
            style: {
              colors: "#000000de"
            },
            formatter: function(val) {
              if (context._data.chartOptions.xaxis.categories.length > 0) {
                return context
                  .dateTimeIsoToLocal(
                    new Date(val)
                      .toISOString()
                      .replace("T", " ")
                      .replace("Z", "")
                  )
                  .substring(0, 16);
              } else {
                return "";
              }
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              color: "#000000de"
            },
            formatter: function(val) {
              return val + " °C";
            }
          }
        },
        legend: {
          position: "top",
          horizontalAlign: "center",
          fontSize: "14px",
          labels: {
            useSeriesColors: false
          }
        },
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: true
          }
        }
      },
      series: this.seriesMontada
    };
  },
  props: {
    values: Array
  },
  methods: {
    dateTimeIsoToLocal
  }
};
</script>
